import actions from './actions';

const initState = {
  schools: null,
  school: null,
  key: null,
};

export default function userReducer(state = initState, action) {
  switch (action.type) {
    case actions.FETCH_SCHOOLS_SUCCESS:
      return {
        ...state,
        schools: action.schools,
      };

    case actions.FETCH_SCHOOL_DETAILS_SUCCESS:
      return {
        ...state,
        school: action.school,
      };

    case actions.SET_FILTER:
      return {
        ...state,
        key: action.key,
      };

    case actions.RESET:
      return {
        ...state,
        schools: null,
        school: null,
      };

    default:
      return state;
  }
}
